import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING } from "const"
import { RrsTemplateRiskRank } from "server/models"
import {
    StateType,
    useInput,
} from "client/utils"
import {
    StoreType,
    RrsTemplateRiskRankValidation,

    SaveRrsTemplateRiskRank,
    setRrsTemplateRiskRankList,
    closeModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    FormGroup,
    Label,
    Input,
    ColorPicker,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

let isMounted: boolean

interface RiskRankEditProps {
    riskRank: RrsTemplateRiskRank
}
const RiskRankEdit = ({
    riskRank,
}: RiskRankEditProps) => {
    const riskRankList = useSelector((state: StoreType) => state.rrsTemplate.riskRankList)

    const modals = useSelector((state: StoreType) => state.system.modals)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [name, setName] = useInput(riskRank.name)
    const [shortName, setShortName] = useInput(riskRank.shortName)
    const [color, setColor] = useState(riskRank.color)

    const [validation, setValidation] = useState<RrsTemplateRiskRankValidation>(null)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    const onClose = () => {
        if (!isMounted) return
        if (modals.length && isMounted) dispatch(closeModal())
    }

    const onSave = () => {
        setSaveState(PENDING)

        const newRiskRankData: RrsTemplateRiskRank = {
            textId: riskRank.textId,
            templateId: riskRank.templateId,
            name,
            shortName,
            color,
        }

        SaveRrsTemplateRiskRank(
            newRiskRankData,
            lang,
        ).then((res) => {
            if (isMounted) {
                setValidation(res)
                setSaveState(IDLE)
            }
            if (res) return

            dispatch(setRrsTemplateRiskRankList({
                ...riskRankList,
                [newRiskRankData.textId]: newRiskRankData,
            }))
            onClose()
        })
    }

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.editRiskRank}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.name}</Label>
                                <Input type="text" value={name} onChange={setName} />
                                <Feedback>{validation && validation.name}</Feedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.shortName}</Label>
                                <Input type="text" value={shortName} onChange={setShortName} />
                                <Feedback>{validation && validation.shortName}</Feedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.color}</Label>
                                <ColorPicker
                                    selectedColor={color}
                                    onChange={setColor}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button
                                variant="success"
                                row
                                onClick={onSave}
                            >
                                {saveState === PENDING ? <SpinnerIcon /> : lang.save}
                            </Button>
                            <Button row onClick={onClose}>{lang.cancel}</Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default RiskRankEdit
